// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBidTZirEbucXDx8Xb9VRm8Y2k0rQRdvcM",
  authDomain: "quotation-react.firebaseapp.com",
  projectId: "quotation-react",
  storageBucket: "quotation-react.appspot.com",
  messagingSenderId: "564855116435",
  appId: "1:564855116435:web:79e2229f6b247bf4c63366",
  measurementId: "G-P7HV5JL86X"
};

export default firebaseConfig;